<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Genera código de artículo segun patron
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="cerrar()"
        tabindex="205">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="form-group">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="codigo" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Código:</label>
                        <div class="col-md-2">
                            <input  [(ngModel)]="valor" style="text-align: left;" class="form-control tsiInput"
                                name="codigo" type="text" 
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10" disabled>
                        </div>
                    </div>
                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="descripcion" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Descripcion:</label>
                        <div class="col-md-4">
                            <select [(ngModel)]="valor"  style="text-align: left;" class="form-control tsiSelect" 
                                name="descripcion" type="text" disabled>
                                <option *ngFor="let lst of tiposInventario " [value]="lst.tipinv">
                                    {{lst.tipinv+' - '+lst.dtipinv}}
                                </option>
                            </select>
                        </div>
                       <!--  <label for="descripcion" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Descripcion:</label>
                        <select id="descripcion" tabindex="1" [(ngModel)]="valor"
                                            name="moneda" #selectTipoInventario class="form-control col-md-1 tsiInput mr-2" class="form-control tsiInput"
                                            style="text-align: left;" >
                                            <option *ngFor="let lst of tiposInventario " [value]="lst.tipinv">
                                                {{lst.tipinv+' - '+lst.dtipinv}}
                                            </option>
                                        </select> -->
                    </div>
                   <!--  <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="agregar" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Agregue las cuotas asociadas al crédito:</label>
                        <div class="col-md-3">
                            <button data-bs-toggle="tooltip" title="Calcular: alt + 'C'" type="button" tabindex="32"
                                class="btn btn-light" >
                                Agregar Cuota</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </form>
    <hr>
    <form>
        <div class="form-group">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row" style="margin-bottom: 0.5rem;" *ngFor="let obj of objPatron;let i=index;">
                        <label for="monto" style="padding: 0.2em 0em 0em .5em; text-transform: capitalize;"
                            class=" col-md-4 control-label col-form-label">{{obj._nomClase}}: </label>
                        <div class="col-md-6">
                           <!--  era 4 -->
                          <container-element [ngSwitch]="obj._kind">
                            <some-element *ngSwitchCase="'Clase'">
                                <div class="form-group row m-0">

                                       <!--  <input tabindex="2"  style="text-align: left;"
                                          class=" col-md-2 form-control tsiInput" 
                                          name="numclase1" type="text"> -->
                                       <select tabindex="3" tabindex="4"
                                        class=" col-md-10 form-control form-control-sm tsiSelect"
                                        (change)="actualizarPatronClase($event.target.value,i,obj._width,obj._codeClass,obj._nomClase)"
                                        name="numclase1">
                                            <option>- Seleccionar -</option>
                                            <option *ngFor="let clase of obj._codigos;" [value]="clase.codigo" >
                                                {{clase.codigo}}-{{clase.descri}}
                                            </option>
                                        </select> 
                                     
                                       <!--  <input  style="text-align: left;"  value="{{campo.codeClass}}" class="form-control tsiInput"
                                         name="monto" type="text" 
                                         onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10" disabled>  -->
                                </div>
                            </some-element>
                            <some-element *ngSwitchCase="'Autogenerado'">
                                <input  style="text-align: left;"  value="{{'0'.repeat(obj._width)}}" class="form-control tsiInput col-md-10"
                                name="monto" type="text" 
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' disabled>
                            </some-element>
                            <some-element *ngSwitchCase="'Texto'">
                                    <input id="texto" name="texto" style="text-align: left;" [(ngModel)]="asd" (change)="actualizarPatronTexto($event.target.value,i,obj._width)" class="form-control tsiInput col-md-10"
                                        name="monto" type="text" 
                                        maxlength="10">
                            </some-element>
                            <some-element *ngSwitchCase="'Separador'">
                                <input  style="text-align: left;" value="{{obj._separador}}"class="form-control  tsiInput col-md-10"
                                name="monto" type="text" disabled>
                            </some-element>
                         </container-element>
                        </div>
                    </div>
                    <!-- <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="monto" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Texto:</label>
                        <div class="col-md-4">
                            <input  style="text-align: left;" class="form-control tsiInput"
                                name="monto" type="text" 
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10">
                        </div>
                    </div>
                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="monto" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Autogenerado:</label>
                        <div class="col-md-4">
                            <input  style="text-align: left;" class="form-control tsiInput"
                                name="monto" type="text" 
                                onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10">
                        </div>
                    </div>
                    <div class="form-group row" style="margin-bottom: 0.5rem;">
                        <label for="monto" style="padding: 0.2em 0em 0em .5em;"
                            class=" col-md-4 control-label col-form-label">Separador:</label>
                        <div class="col-md-4">
                            <input  style="text-align: left;" class="form-control  tsiInput"
                                name="monto" type="text">
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </form>
    <hr>
    <div style="text-align: center; font-size: xx-large; color: black;"><strong>{{valPatron}}</strong></div>
</div>
<div class="modal-footer">
    
    <button type="button" class="btn btn-rounded btn-info m-b-15" tabindex="5" (click)="_guardar()"><i
            class="fa fa-save"></i> Registrar</button>
    <button type="button" class="btn btn-rounded btn-warning m-b-15"  tabindex="6" (click)="_close()"><i
            class="fa fa-times-circle"></i> Cancelar</button>
</div>
